<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <CustomerInfo></CustomerInfo>
      <CustomerTransactions></CustomerTransactions>
      <AccountUser :id="$route.params.id"></AccountUser>
    </div>
  </div>
</template>

<script>
import CustomerInfo from "../CustomerInfo";
import CustomerTransactions from "../CustomerTransactions";
import AccountUser from "./AccountUser.vue";
export default {
  name: "CustomerDetail",
  components: { CustomerTransactions, CustomerInfo, AccountUser },
}
</script>

<style scoped>
.info th {
  text-align: right;
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/views/CustomerDetail.vue